export default __webpack_public_path__ + "static/media/sadaqasbg.3a139a41.png";